import React from 'react';
import { Button, Flex } from '@app/ui';

type PostCarouselNavigationProps = {
    activeSlideIndex: number;
    activeSlideLabel: string;
    totalSlides: number;
    onChange: (slideIndex: number) => void;
    showButtons?: boolean;
};

const PostCarouselNavigation: React.FC<PostCarouselNavigationProps> = ({
    activeSlideIndex,
    activeSlideLabel,
    totalSlides,
    onChange,
    showButtons = true,
}) => (
    <Flex
        className="modal-v2-carousel-nav"
        justify="center"
        align="center"
        gap={8}
    >
        {showButtons && (
            <Button
                aria-label="Previous carousel slide"
                className="modal-v2-carousel-nav-button"
                size="small"
                disabled={activeSlideIndex === 0}
                onClick={() => onChange(activeSlideIndex - 1)}
            >
                ←
            </Button>
        )}
        <span>{activeSlideLabel}</span>
        {showButtons && (
            <Button
                aria-label="Next carousel slide"
                className="modal-v2-carousel-nav-button"
                size="small"
                disabled={activeSlideIndex === totalSlides - 1}
                onClick={() => onChange(activeSlideIndex + 1)}
            >
                →
            </Button>
        )}
    </Flex>
);

export default PostCarouselNavigation;
